import { ENTITY_TYPE } from '../utilities/CONSTANTS';

const mentionEntityStrategy = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return entityKey && contentState.getEntity(entityKey).getType().toUpperCase() === ENTITY_TYPE.MENTION;
        },
        callback,
    );
};

export default mentionEntityStrategy;
